import * as K from '../typing';

export default interfaceName => (K[`${interfaceName}Keys`] ? K[`${interfaceName}Keys`] : []);
